import type { AxiosError } from 'axios'

import router from '@/router'
import store from '@/store'

import type { ErrorContext, ErrorHandlerPort, ErrorHandlerResult } from '../ports/ErrorHandlerPort'

/**
 * Handles authentication errors (401 Unauthorized)
 * Redirects user to login page and clears session
 */
export class InvalidTokenErrorHandler implements ErrorHandlerPort {
  canHandle(error: AxiosError, context: ErrorContext): boolean {
    return error.response?.status === 401 && context.url !== '/authenticate'
  }

  async handleError(): Promise<ErrorHandlerResult> {
    const savedToPath = router.options.history.location

    await store.dispatch('FedLogOut')
    sessionStorage.setItem('savedToPath', savedToPath)
    router.push({ path: '/login', query: { sessionLost: true } })

    return {
      handled: true,
      shouldShowToast: false, // Don't show toast, redirect handles the UX
      shouldReject: true,
      customAction: async () => {
        // Custom action already performed above
      }
    }
  }
}
